import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'hr': {
        items: [
            {
                title: "O nama",
                link: "#opceInformacije",
                icon: 'fas fa-info-circle'
            },
            {
                title: "Arhiva",
                link: "#arhiva",
                icon: 'fas fa-archive'
            },
            {
                title: "Upute i dokumenti",
                link: "#upute",
                icon: 'far fa-clipboard'
            },
            {
                title: "Uredništvo",
                link: "#urednistvo",
                icon: 'fas fa-user-edit'
            },
            {
                title: "Uredničko vijeće",
                link: "#urednicko_vijece",
                icon: 'fas fa-user-friends'
            },
            {
                title: "Međunarodno znanstveno vijeće",
                link: "#medunarodno_znanstveno",
                icon: 'fas fa-users'
            },
            {
                title: "Kontakt",
                link: "#kontakt",
                icon: 'fas fa-phone-square'
            }
        ],
        about: 'O nama',
        // about_text: `Znanstveni časopis South Eastern European Journal of Communication osmišljen je kao znanstvena publikacija otvorenoga pristupa koja objavljuje recenzirane radove. Dostavljeni radovi koji zadovoljavaju upute podliježu dvostrukoj anonimnoj recenziji, dakle ocjenjuju ih dva recenzenta, pri čemu su identiteti autora i recenzenata obostrano nepoznati. Časopis će izlaziti dva puta godišnje, a radovi će se objavljivati na engleskome ili hrvatskome jeziku. Časopis će biti dostupan u tiskanoj i elektroničkoj formi. Naklada tiskanoga izdanja je 500 primjeraka, a slobodno preuzimanje elektroničke verzije časopisa bit će omogućeno na njegovoj mrežnoj stranici. Intencija časopisa je da bude tematski, odnosno da u svakome broju dominantan broj radova obrađuje jednu temu, međutim to neće predstavljati ograničenje da i drugi radovi koji su uspješno prošli recenzentski postupak budu objavljeni.
        // <br><br>
        // Uredništvo zahvaljuje svima koji su podržali i na bilo koji način pridonijeli pokretanju časopisa. Posebnu zahvalu upućujemo Filozofskom fakultetu, Sveučilištu u Mostaru, kao i svim kolegicama i kolegama koji su prihvatili članstvo u njegovu uredničkome i međunarodno-znanstvenome vijeću.`,
        about_text: `Znanstveni časopis South Eastern European Journal of Communication osmišljen je
                    kao znanstvena publikacija otvorenoga pristupa koja objavljuje recenzirane radove.
                    Dostavljeni radovi koji zadovoljavaju osnovne upute podliježu dvostrukoj anonimnoj
                    recenziji, dakle ocjenjuju ih dva recenzenta, pri čemu su identiteti autora i
                    recenzenata obostrano nepoznati.
                    <br>
                    Časopis izlazi dva puta godišnje, a radovi se objavljuju na engleskome ili hrvatskome
                    jeziku.
                    <br>
                    Dostupan je u tiskanoj i elektroničkoj formi.`,
        editorial: 'Uredništvo',
        editor_in: 'Glavna urednica',
        executive: 'Izvršni urednici',
        secretary: 'Tajnica',
        archive: 'Arhiva',
        archive_list: [
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/5-SEEJC-elektronska-verzija.pdf',
                no: 'Volume 1, No 1, Summer 2019'
            },
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/SEEJC-2.pdf',
                no: 'Volume 1, No 2, Winter 2019'
            },
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/SEEJC1_Vol2.pdf',
                no: 'Volume 2, No 1, Summer 2020'
            },
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/SEEJC_Vol2_No2.pdf',
                no: 'Volume 2, No 2, Winter 2020'
            },
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/Casopis_SEEJC_Vol3_No1_web.pdf',
                no: 'Volume 3, No 1, 2021'
            }
        ],
        instruction: 'Upute i dokumenti',
        instruction_text: `<p>Časopis South Eastern European Journal of Communication znanstvena je publikacija otvorenog pristupa koja objavljuje recenzirane radove. Dostavljeni radovi, koji zadovoljavaju upute o pisanju, podliježu dvostrukoj anonimnoj recenziji - ocjenjuju ih dva recenzenta, pri čemu su identiteti autora i recenzenata obostrano nepoznati. Ukoliko je ocjena jednog od recenzenata negativna, rad će biti upućen na dodatnu recenziju. Temeljem recenzije uredništvo donosi odluku o konačnoj kategorizaciji rada na način njegova prihvaćanja, traženja dorada ili ispravaka, ili odbijanja. Dorađene ili ispravljene radove autori trebaju poslati Uredništvu najkasnije u roku od 8 dana od primitka primjedbi.</p>
                        <p>U časopisu se objavljuju sljedeće kategorije radova:</p>
                        <ul>
                            <li>izvorni znanstveni rad,</li>
                            <li>prethodno priopćenje,</li>
                            <li>pregledni znanstveni rad,</li>
                            <li>stručni rad.</li>
                        </ul>
                        <p>Iznimno, Uredništvo časopisa može prihvatiti i drugu vrstu rada koji nije kategoriziran, ako se isti bude smatrao korisnim za čitateljstvo.</p>
                        <p>Svi radovi trebaju biti pisani na engleskom ili hrvatskom jeziku. Dostavljeni tekstovi trebaju biti lektorirani. Obvezno je dostaviti i podatke o prevoditelju i/ili lektoru: ime i prezime, naziv i adresu institucije, adresu e-pošte i broj telefona.</p>
                        <p>Pri dostavljanju rada autor dostavlja i izjavu da je rad autorsko djelo, da nije već objavljen, niti ponuđen drugom časopisu na objavljivanje. Izneseni stavovi u radu isključiva su odgovornost autora.</p>
                        <p>Svaki rad treba sadržavati:</p>
                        <ol>
                            <li>ime i prezime i akademski stupanj autora/ice;</li>
                            <li>naziv institucije u kojoj radi;</li>
                            <li>kontakt autora (e-mail, telefon i adresa), s navođenjem autora za korespondenciju u svim fazama recenziranja i objavljivanja, ukoliko je više autora;</li>
                            <li>naslov rada na hrvatskom i engleskom jeziku;</li>
                            <li>sažetak (opći prikaz teme, metodologiju, rezultate i zaključak - do 250 riječi) i ključne riječi (do pet ključnih riječi) na hrvatskom i engleskom jeziku;</li>
                            <li>popis literature</li>
                        </ol>
                        <p>Radove treba pisati u MS Wordu, a pohraniti u „.doc ili .docx“ formatu. Obvezna je uporaba fonta Times New Roman CE, veličina 12, prored 1,5. U pozivnim bilješkama veličina slova je 10, a prored jednostruki. Veličina stranice je A4, gornja i donja margina 25 mm, a lijeva i desna 20 mm.</p>
                        <p>Rad i svi prilozi dostavljaju se isključivo u elektroničkom obliku. Preporučena duljina teksta je u rasponu od 10 do 15 autorskih kartica (1 kartica sadrži 1800 znakova s razmacima - 30 redaka sa 60 znakova u retku), uključujući sve dijelove rada.</p>
                        <p>U pisanju rada autori primjenjuju APA stil referenciranja, koji podrazumijeva navođenje referenci u tekstu, dok se u pozivnim bilješkama navode ostale napomene i podaci, ukoliko ih ima, a svi ostali podaci u bibliografiji.</p>
                        <p>Radove koji ne zadovoljavaju kriterije opisane u navedenim uputama, uredništvo časopisa će vratiti autoru.</p>
                        <p>Časopis se pridržava najviših etičkih standarda slijedeći smjernice najbolje prakse u svim stadijima pripreme i objave rada. Pretpostavlja se da radovi nisu objavljeni u drugim publikacijama. Autori su suglasni s objavom radova na web stranici časopisa, a časopis zadržava i sva ostala prava.</p>
                        <p>Radovi se dostavljaju elektroničkom poštom na adresu: <a>seejc@sum.ba</a></p>`,
        editorial_council: 'Uredničko vijeće',
        international_scientific_council: 'Međunarodno znanstveno vijeće',
        contact: 'Kontakt',
        call_for_papers: 'Poziv za dostavu radova',
        download: 'Preuzmite',
        link: 'https://seejc.sum.ba/casopisi/Poziv_za_dostavu_radova_za_SEEJC.docx',
        documents: [
            {
                title: 'Upute autorima',
                link: 'https://web-admin.sum.ba/api/storage/UputeAutorima_SEEJC_1646834290_95.pdf'
            },
            {
                title: 'Upute recenzentima',
                link: 'https://web-admin.sum.ba/api/storage/UputeRecenzentima_SEEJC_1646834290_45.pdf'
            },
            {
                title: 'Dokument o izdavačkoj etici',
                link: 'https://web-admin.sum.ba/api/storage/Dokument_o_izdavackoj_etici_SEEJC_1648294500_58.pdf'
            },
        ],
        urednicko_vjece: [
            {
                name: "Zoran Tomić",
                institution: 'Sveučilište u Mostaru',
            },
            {
                name: "Iko Skoko",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Božo Skoko",
                institution: 'Sveučilište u Zagrebu'
            },
            {
                name: "Miro Radalj",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Marija Putica",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Marijan Primorac",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Marko Odak",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Đorđe Obradović",
                institution: 'Sveučilište u Dubrovniku'
            },
            {
                name: "Ivica Musić",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Damir Kukić",
                institution: 'Univerzitet u Zenici'
            },
            {
                name: "Milica Kostić Stanković",
                institution: 'Univerzitet u Beogradu'
            },
            {
                name: "Zdenko Klepić",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Damir Jugo",
                institution: 'Edward Bernays Visoka škola za komunikacijski menadžment'
            },
            {
                name: "Nevenko Herceg",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Bojan Hadžihalilović",
                institution: 'Univerzitet u Sarajevu'
            },
            {
                name: "Nenad Brkić",
                institution: 'Univerzitet u Sarajevu'
            },
            {
                name: "Aleksandar Bogdanić",
                institution: 'Univerzitet u Banjoj Luci'
            },
            {
                name: "Sanja Bijakšić",
                institution: 'Sveučilište u Mostaru'
            },
            {
                name: "Antonia Tomaš",
                institution: "Sveučilište Sjever"
            }
        ],
        institution: 'Sveučilište u Mostaru',
        medunarodno_znanstveno: ["W. Timothy Coombs (SAD)", "Miriam Diez Bosch (Španjolska)", "Damir Dobrinić (Hrvatska)", "James E. Grunig (SAD)", "Miro Jakovljević (Hrvatska)", "Giuseppe Mazza (Italija)", "Klement Podnar (Slovenija)", "Maria Popović (Crna Gora)", "Pavica Sheldon (SAD)", "Ana Tkalac Verčič (Hrvatska)", "Boban Tomić (Srbija)", "Dennis L. Wilcox (SAD)"],
    },
    'en': {
        items: [
            {
                title: "About us",
                link: "#opceInformacije",
                icon: 'fas fa-info-circle'
            },
            {
                title: "Archive",
                link: "#arhiva",
                icon: 'fas fa-archive'
            },
            {
                title: "Instructions and documents",
                link: "#upute",
                icon: 'far fa-clipboard'
            },
            {
                title: "Editorial board",
                link: "#urednistvo",
                icon: 'fas fa-user-edit'
            },
            {
                title: "Editorial council",
                link: "#urednicko_vijece",
                icon: 'fas fa-user-friends'
            },
            {
                title: "International scientific council",
                link: "#medunarodno_znanstveno",
                icon: 'fas fa-users'
            },
            {
                title: "Contact",
                link: "#kontakt",
                icon: 'fas fa-phone-square'
            }
        ],
        about: 'About us',
        // about_text: `South Eastern European Journal of Communication has been designed as a scientific publication of the open approach for publishing reviewed articles. This journal uses double-blind review, which means that both the reviewer and author identities are concealed from the reviewers, and vice versa, throughout the review process. The journal will be issued two times a year and papers will be published dominantly in English, but also in Croatian language. It will be accessible in printed and electronic version. The intention of the South Eastern European Journal of Communication is to be thematic, which means that in every number of the magazine there should be a dominant number of papers which deal with a certain topic. However, that will not be a restriction for other papers which successfully underwent the review to be published.
        // <br><br>
        // The editorial board gives acknowledgment to everybody who supported and helped initiating this magazine in any way. A special acknowledgment is given to Faculty of Humanities and Social Sciences, University of Mostar, all colleagues who accepted membership in its editorial as well as scientific board.`,
        about_text: `South Eastern European Journal of Communication has been designed as a
                    scientific publication of the open approach for publishing reviewed articles.
                    This journal uses double-blind review, which means that both the reviewer and
                    author identities are concealed from the reviewers, and vice versa, throughout the
                    review process.
                    <br>
                    The journal is issued two times a year and papers are published in English, and in
                    Croatian language. 
                    <br>
                    It’s available in printed and electronic version.`,
        editorial: 'Editorial Board',
        editor_in: 'Editor-in-Chief',
        executive: 'Executive Editors',
        secretary: 'Secretary',
        archive: 'Archive',
        archive_list: [
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/5-SEEJC-elektronska-verzija.pdf',
                no: 'Volume 1, No 1, Summer 2019'
            },
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/SEEJC-2.pdf',
                no: 'Volume 1, No 2, Winter 2019'
            },
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/SEEJC1_Vol2.pdf',
                no: 'Volume 2, No 1, Summer 2020'
            },
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/SEEJC_Vol2_No2.pdf',
                no: 'Volume 2, No 2, Winter 2020'
            },
            {
                title: 'South Eastern European Journal of Communication',
                link: 'https://seejc.sum.ba/casopisi/Casopis_SEEJC_Vol3_No1_web.pdf',
                no: 'Volume 3, No 1, 2021'
            }
        ],
        instruction: 'Instruction and documents',
        instruction_text: `<p>The South Eastern European Journal of Communication is a scientific open-access publication that publishes reviewed papers. The submitted papers that comply with writing instructions are subject to a double anonymous review - evaluated by two reviewers. The identities of both authors and reviewers are mutually unknown. If one of the reviewers gives the negative grade, the paper will be forwarded to additional review. Based on the reviews, the Editorial Board decides about the final categorization of the paper in terms of its acceptance, possible corrections, or rejection. The revised or corrected papers should be sent to the Editorial Board within the 8 days from the day of receiving the comments.</p>
        <p>The following categories of works are published in the journal:</p>
        <ul>
            <li>original scientific paper,</li>
            <li>preliminary communication,</li>
            <li>scientific review,</li>
            <li>professional paper.</li>
        </ul>
        <p>Exceptionally, if the Editorial Board considers a certain non-categorized type of paper useful for the readers, it can be accepted as well.</p>
        <p>When submitting the paper, the author has to submit a statement that the paper is original, that it has not been published yet or offered to another journal for publication. The statement falls under the responsibility of the author.</p>
        <p>Every paper has to include:</p>
        <ol>
            <li>name, last name and academic title of the author</li>
            <li>name of the home institution;</li>
            <li>author's contact (e-mail, telephone and address), indicating author for correspondence in review and publishing phases, if there are more authors</li>
            <li>title in Croatian and English language;</li>
            <li>abstract (general presentation of the topic, methodology, results and conclusion – up to 250 words) and keywords (up to five keywords) in Croatian and English language;</li>
            <li>literature list.</li>
        </ol>
        <p>The papers should be written in MS Word and stored in ".doc or .docx" format. It is mandatory to use Times New Roman CE font, size 12, space 1.5. In notes, the letter size is 10, and a single-spaced. The page size is A4, the top and bottom margins are 25 mm, and the left and right are 20 mm.</p>
        <p>The paper and all attachments have to be sent in the electronic form. The recommended length of text ranges from 10 to 15 cards (1 card contains 1800 characters with spaces - 30 rows with 60 characters per line), including all parts of the paper.</p>
        <p>When citing, the authors use APA style, which implies writing references in the text, while quoting notes include other notes and data. All other data are included in the bibliography.</p>
        <p>The Journal respects highest ethical standard following directions of the best practice in all phases of preparing and publishing a paper. The papers are supposed not to be published in other journals. The authors agree to publish their papers on website of the journal, whereas the journal retains all other rights.</p>
        <p>The Editorial Board of the journal will return all the papers that do not meet the criteria described in these instructions.</p>
        <p>The papers are submitted at <a>seejc@sum.ba</a></p>`,
        editorial_council: 'Editorial Council',
        international_scientific_council: 'International Scientific Council',
        contact: 'Contact',
        call_for_papers: 'Call for papers',
        download: 'Download',
        link: 'https://seejc.sum.ba/casopisi/Call_for_papers_SEEJC.docx',
        documents: [
            {
                title: 'Instruction for authors',
                link: 'https://web-admin.sum.ba/api/storage/INSTRUCTIONS_FOR_AUTHORS_1651236429_80.pdf'
            },
            {
                title: 'Instruction for reviewers',
                link: 'https://web-admin.sum.ba/api/storage/INSTRUCTIONS_FOR_REVIEWERS_1651236429_29.pdf'
            },
            {
                title: 'Ethical guidelines for journal publishing',
                link: 'https://web-admin.sum.ba/api/storage/ETHICAL_GUIDELINES_FOR_JOURNAL_PUBLISHING_1651236429_39.pdf'
            },
        ],
        urednicko_vjece: [
            {
                name: "Zoran Tomić",
                institution: 'University of Mostar',
            },
            {
                name: "Iko Skoko",
                institution: 'University of Mostar'
            },
            {
                name: "Božo Skoko",
                institution: 'University of Zagreb'
            },
            {
                name: "Miro Radalj",
                institution: 'University of Mostar'
            },
            {
                name: "Marija Putica",
                institution: 'University of Mostar'
            },
            {
                name: "Marijan Primorac",
                institution: 'University of Mostar'
            },
            {
                name: "Marko Odak",
                institution: 'University of Mostar'
            },
            {
                name: "Đorđe Obradović",
                institution: 'University of Dubrovnik'
            },
            {
                name: "Ivica Musić",
                institution: 'University of Mostar'
            },
            {
                name: "Damir Kukić",
                institution: 'University of Zenica'
            },
            {
                name: "Milica Kostić Stanković",
                institution: 'University of Belgrade'
            },
            {
                name: "Zdenko Klepić",
                institution: 'University of Mostar'
            },
            {
                name: "Damir Jugo",
                institution: 'Edward Bernays University College'
            },
            {
                name: "Nevenko Herceg",
                institution: 'University of Mostar'
            },
            {
                name: "Bojan Hadžihalilović",
                institution: 'University of Sarajevo'
            },
            {
                name: "Nenad Brkić",
                institution: 'University of Sarajevo'
            },
            {
                name: "Aleksandar Bogdanić",
                institution: 'University of Banja Luka'
            },
            {
                name: "Sanja Bijakšić",
                institution: 'University of Mostar'
            },
            {
                name: "Antonia Tomaš",
                institution: "University North"
            }
        ],
        institution: 'University of Mostar',
        medunarodno_znanstveno: ["W. Timothy Coombs (USA)", "Miriam Diez Bosch (Spain)", "Damir Dobrinić (Croatia)", "James E. Grunig (USA)", "Miro Jakovljević (Croatia)", "Giuseppe Mazza (Italy)", "Klement Podnar (Slovenia)", "Maria Popović (Montenegro)", "Pavica Sheldon (USA)", "Ana Tkalac Verčič (Croatia)", "Boban Tomić (Serbia)", "Dennis L. Wilcox (USA)"],
    }
}

const i18n = new VueI18n({
    locale: 'hr', // set locale
    fallbackLocale: 'hr', // set fallback locale
    messages, // set locale messages
});

export default i18n;